import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from '../Components/Header'
import SideMenu from '../Components/SideMenu'
import { AiOutlineAlignLeft } from "react-icons/ai";

const ImportManualDetailsOne = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen">
      <div className="px-4">
        <Header />
      </div>
      <div className="flex flex-1 overflow-hidden">
        <SideMenu className="hidden lg:block w-1/4 bg-gray-200" />
        <div className="flex-1 px-6 py-4 overflow-auto">
          <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
            <h1>Beneficiary Details</h1>
          </div>
          {/* <AiOutlineAlignLeft /> */}
          <div className="flex justify-end space-x-4 mt-4">
            <button className="bg-[#241C68] text-white rounded-md py-1 px-2">
              Import From Excel
            </button>
            <button
              className="bg-[#241C68] text-white rounded-md py-1 px-2"
              onClick={() => navigate("/ManualBeneficiary")}
            >
              Enter Manual
            </button>
            <button className="bg-[#241C68] text-white rounded-md py-1 px-2">
              Export
            </button>
          </div>

          <div className="">
            <section className="mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-14">
              <table className="w-full sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-1/3">
                <thead>
                  <tr className="border-b-2 border-[#B4B4B4]">
                    <th className="p-2 text-[#929292]">S. No.</th>
                    <th className="p-2 text-[#929292]">Beneficiary Type</th>
                    <th className="p-2 text-[#929292]">Khata No.</th>
                    <th className="p-2 text-[#929292]">Beneficiary Name</th>
                    <th className="p-2 text-[#929292]">Village</th>
                    <th className="p-2 text-[#929292]">Compensation Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="p-2">
                      <input className="w-full" type="text" />
                    </td>
                    <td className="p-2">
                      <input className="w-full" type="text" />
                    </td>
                    <td className="p-2">
                      <input className="w-full" type="text" />
                    </td>
                    <td className="p-2">
                      <input className="w-full" type="text" />
                    </td>
                    <td className="p-2">
                      <input className="w-full" type="text" />
                    </td>
                    <td className="p-2">
                      <input className="w-full" type="text" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </div>
          <div className="flex justify-center items-center">
            <button className="rounded-md py-2 px-10 sm:px-16 md:px-20 lg:px-32 xl:px-52 text-white bg-[#241C68]">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportManualDetailsOne;
